import DownloadIcon from '@/common/assets/icons/downloadIcon.svg?react';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import useDownloadExtension from '@/common/components/imageGallery/hooks/useDownloadExtension';
import { DownloadExtensionProps } from '@/common/components/imageGallery/types/imageCard.type';
import { Box } from 'styled-system/jsx';

export const DownloadExtension = ({ src }: DownloadExtensionProps) => {
  const { download, loading } = useDownloadExtension({ src });
  return (
    <Box onClick={download} position="absolute" top="0.5rem" left="0.5rem">
      {loading ? (
        <Box bgColor="white" borderRadius="8px">
          <CircularLoading width="30" color="colors.purple-primary" />
        </Box>
      ) : (
        <DownloadIcon />
      )}
    </Box>
  );
};
